export type DashboardPeriod = 'daily' | 'weekly' | 'monthly' | 'yearly'

export const DASHBOARD_PERIODS: { id: DashboardPeriod; label: string }[] = [
  { id: 'daily', label: 'Daily' },
  { id: 'weekly', label: 'Weekly' },
  { id: 'monthly', label: 'Monthly' },
  { id: 'yearly', label: 'Yearly' },
]

export function getDashboardDateRange(
  period: DashboardPeriod,
  now: Date = new Date(),
): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  const fmt = (d: Date) =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

  switch (period) {
    case 'daily':
      return fmt(now)
    case 'weekly': {
      const dow = now.getDay() === 0 ? 7 : now.getDay()
      const mon = new Date(now)
      mon.setDate(now.getDate() - (dow - 1))
      const sun = new Date(mon)
      sun.setDate(mon.getDate() + 6)
      return `${fmt(mon)} → ${fmt(sun)}`
    }
    case 'monthly': {
      const start = new Date(now.getFullYear(), now.getMonth(), 1)
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      return `${fmt(start)} → ${fmt(end)}`
    }
    case 'yearly':
      return `${now.getFullYear()}-01-01 → ${now.getFullYear()}-12-31`
  }
}
